import { useState } from 'react';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

/**
 * Campo somente-leitura com botão de copiar — para valores que o gestor precisa
 * levar para outro sistema (URL de webhook, token, endereço do TEF) e que são
 * longos o bastante para errar digitando.
 */
export function CampoCopiavel({
  rotulo,
  valor,
  ajuda,
}: {
  rotulo: string;
  valor: string;
  ajuda: string;
}): JSX.Element {
  const [copiado, setCopiado] = useState(false);

  async function copiar(): Promise<void> {
    try {
      await navigator.clipboard.writeText(valor);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      // Clipboard bloqueado (contexto não seguro/permissão negada): o campo é
      // selecionável, o usuário copia na mão.
    }
  }

  return (
    <TextField
      label={rotulo}
      value={valor}
      helperText={copiado ? 'Copiado!' : ajuda}
      size="small"
      fullWidth
      InputProps={{
        readOnly: true,
        sx: { fontFamily: 'monospace', fontSize: 13 },
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={copiado ? 'Copiado!' : 'Copiar'}>
              <IconButton onClick={copiar} edge="end" size="small" aria-label={`Copiar ${rotulo}`}>
                {copiado ? <CheckIcon fontSize="small" color="success" /> : <ContentCopyIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      onFocus={(e) => e.target.select()}
    />
  );
}
